import React, {Component} from "react";
import PropTypes from "prop-types";
import ProjectModel from "../models/project";

export default class ProjectListItem extends Component {
    render() {
        let className = this.props.isActive ? 'list-group-item active' : 'list-group-item';
        return (
            <li className={className} onClick={() => this.props.onClick(this.props.model.id)}>
                {this.props.model.id}, {this.props.model.name}, {this.props.model.number}
            </li>
        )
    }
}

ProjectListItem.propTypes = {
    model: PropTypes.instanceOf(ProjectModel).isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/ProjectListItem.js